<div class="contest-timer__wrapper" [ngClass]="alignIconClass">
    <mat-icon svgIcon="timer"></mat-icon>
    <div class="contest-timer__header">{{ title | translate }}</div>
    <div class="contest-timer__content">{{ timeRemaining }}</div>
    <div class="contest-timer__footer"
         aria-hidden="true">
        <div>{{ "contest.days" | translate }}</div>
        <div>{{ "contest.hours" | translate }}</div>
        <div>{{ "contest.minutes" | translate }}</div>
    </div>
</div>
